const PUBLIC_WEBCHAT_HTTP_FALLBACK_KEY = 'runai:public-webchat:http-fallback';

const PUBLIC_WEBCHAT_HTTP_FALLBACK_HOSTS = new Set([
  'run.ceo',
  'public.run.ceo',
  'localhost',
  '127.0.0.1',
]);

const PUBLIC_WEBCHAT_HTTP_FALLBACK_PATHS = new Set([
  '/webchat',
  '/webchat/',
  '/webchat/index.html',
]);

type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function getSessionStorage(storage?: StorageLike): StorageLike | undefined {
  return storage || (typeof window !== 'undefined' ? window.sessionStorage : undefined);
}

export function shouldUsePublicWebchatHttpFallback(storage?: StorageLike): boolean {
  return getSessionStorage(storage)?.getItem(PUBLIC_WEBCHAT_HTTP_FALLBACK_KEY) === '1';
}

export function markPublicWebchatHttpFallback(storage?: StorageLike): void {
  getSessionStorage(storage)?.setItem(PUBLIC_WEBCHAT_HTTP_FALLBACK_KEY, '1');
}

export function clearPublicWebchatHttpFallback(storage?: StorageLike): void {
  getSessionStorage(storage)?.removeItem(PUBLIC_WEBCHAT_HTTP_FALLBACK_KEY);
}

export function isPublicWebchatHttpFallbackEligible(
  pathname = window.location.pathname,
  hostname = window.location.hostname,
): boolean {
  const normalizedHost = hostname.trim().toLowerCase();
  const normalizedPath = pathname || '/';

  return PUBLIC_WEBCHAT_HTTP_FALLBACK_HOSTS.has(normalizedHost)
    && PUBLIC_WEBCHAT_HTTP_FALLBACK_PATHS.has(normalizedPath);
}
